import axios from 'axios';
import { API_GET_HISTORIES } from '../../../endpoint';
import { SUCCESS_API_GET_HISTORIES } from '../../../actionTypes';
import {
  checkCancelToken,
  consolelog,
  delCancelToken,
} from '../../../../lib/tools';
import { createCancelToken, handleErrorResponse } from '../../apis';
import { configureAxiosForJSON } from '../../axiosConfig';

/**
 * 自身の通話履歴の一覧を取得する。
 * 取得したデータは、reduxで管理する。
 * @param {string} apiToken - APIトークン
 * @param {string} groupId - グループID。このグループに紐づく通話履歴一覧を取得する。
 * @param {string} operatorName - 検索する作業者名
 */
const getCallHistories = (apiToken, groupId, operatorName) => dispatch => {
  consolelog('[API CALL] getHistories()', apiToken);
  configureAxiosForJSON(apiToken);
  const { cancelToken, cancelTokenKey } = createCancelToken('getHistories');
  const url = API_GET_HISTORIES;

  return axios
    .get(url, {
      cancelToken,
      params: {
        groupIds: groupId,
        operatorName,
      },
    })
    .then(res => {
      if (checkCancelToken(cancelTokenKey)) {
        dispatch({
          type: SUCCESS_API_GET_HISTORIES,
          payload: res.data?.histories || [],
        });
      }
      delCancelToken(cancelTokenKey);
    })
    .catch(thrown => {
      if (!axios.isCancel(thrown)) {
        handleErrorResponse(thrown, dispatch);
      }
      delCancelToken(cancelToken);
    });
};

export default getCallHistories;
